module.exports = __webpack_public_path__ + "static/media/No Joint Space.b873fdd7.png";